import { Badge } from '@/components/UI';
import type { BackendIssue } from './types';

interface BackendIssueQueueSectionProps {
    issues: BackendIssue[] | undefined;
    isLoading: boolean;
    errorMessage: string | undefined;
}

const BackendIssueQueueSection = ({ issues, isLoading, errorMessage }: BackendIssueQueueSectionProps) => (
    <div className="rounded border border-zinc-800 bg-zinc-950/40 p-3">
        <div className="mb-2 flex items-center justify-between gap-2">
            <div className="font-medium text-white">Backend Issue Queue</div>
            {issues && <Badge variant="secondary">{issues.length} shown</Badge>}
        </div>
        {isLoading ? (
            <div className="text-sm text-zinc-500">Loading backend issues...</div>
        ) : errorMessage ? (
            <div className="text-sm text-red-300">{errorMessage}</div>
        ) : issues && issues.length > 0 ? (
            <div className="divide-y divide-zinc-800">
                {issues.map((issue) => (
                    <div className="grid gap-1 py-2 text-sm md:grid-cols-[130px_minmax(180px,1fr)_120px_100px]" key={issue.id}>
                        <div className="text-zinc-500">
                            #{issue.id} {issue.issueType}
                        </div>
                        <div className="min-w-0">
                            <div className="truncate text-zinc-200">{issue.featureKey}</div>
                            <div className="truncate text-xs text-zinc-500">{issue.evidenceSummary}</div>
                        </div>
                        <Badge variant={issue.severity === 'error' || issue.severity === 'critical' ? 'danger' : 'warning'}>
                            {issue.severity}
                        </Badge>
                        <Badge variant={issue.status === 'codex_queued' ? 'danger' : issue.status === 'triaged' ? 'warning' : 'secondary'}>
                            {issue.status}
                        </Badge>
                    </div>
                ))}
            </div>
        ) : (
            <div className="text-sm text-zinc-500">No active backend issues for the current filters.</div>
        )}
    </div>
);

export default BackendIssueQueueSection;
